// Canvas page navigation helpers for CollabService connection management

import { isNotProduction } from 'smbls'

export async function enterCanvas() {
  const { projectId, branch = 'main', pro } = this.getRootState()

  if (!this.sdk) {
    if (isNotProduction()) {
      console.warn('[enterCanvas] SDK not available')
    }
    return
  }

  if (!projectId) {
    if (isNotProduction()) {
      console.warn('[enterCanvas] Missing projectId, skipping connection')
    }
    return
  }

  try {
    if (!this.sdk.isConnected()) {
      await this.sdk.connect({
        projectId,
        branch,
        pro
      })
      console.log(
        '[enterCanvas] Connected to collaboration for project:',
        projectId
      )
    }
  } catch (error) {
    if (isNotProduction()) {
      console.error('[enterCanvas] Failed to connect to collaboration:', error)
    }
  }
}

export function leaveCanvas() {
  if (!this.sdk?.isConnected()) {
    return
  }

  try {
    this.sdk.disconnect()
    if (isNotProduction()) {
      console.log('[leaveCanvas] Disconnected from collaboration')
    }
  } catch (error) {
    console.error(
      '[leaveCanvas] Error disconnecting from collaboration:',
      error
    )
  }
}

export async function switchCanvasProject(projectData) {
  const { projectId, branch = 'main', pro } = projectData || {}

  if (!this.sdk?.getService) {
    if (isNotProduction()) {
      console.warn('[switchCanvasProject] SDK not available')
    }
    return
  }

  try {
    if (!projectId) {
      throw new Error('projectId is required to switch collaboration room')
    }

    const collabService = this.sdk.getService('collab')
    const normalizedBranch = branch || 'main'
    const desiredLiveFlag = Boolean(pro)

    if (collabService?.getConnectionInfo) {
      const connectionInfo = collabService.getConnectionInfo()
      const {
        connected = false,
        connecting = false,
        projectId: currentProjectId,
        branch: currentBranch,
        live: currentLive
      } = connectionInfo || {}

      const matchesProject = currentProjectId === projectId
      const matchesBranch = (currentBranch || 'main') === normalizedBranch
      const matchesLive = Boolean(currentLive) === desiredLiveFlag

      if (
        (connected || connecting) &&
        matchesProject &&
        matchesBranch &&
        matchesLive
      ) {
        if (isNotProduction()) {
          console.log(
            '[switchCanvasProject] Already connected to requested collaboration room; skipping reconnect'
          )
        }
        return
      }
    }

    // Connect to new project's collaboration room
    await this.sdk.connect({
      projectId,
      branch: normalizedBranch,
      pro
    })
  } catch (error) {
    console.error(
      '[switchCanvasProject] Failed to switch collaboration room:',
      error
    )
  }
}
